export default __webpack_public_path__ + "abb4802be2f695acc70ba386aa1340bb.png";